import type { ElementType, HTMLAttributes, ReactNode } from "react";

type Props = {
  children: ReactNode;
  /** Default `bdi` for inline technical values. */
  as?: ElementType;
  className?: string;
  mono?: boolean;
} & Omit<HTMLAttributes<HTMLElement>, "children" | "dir" | "className">;

/**
 * Isolates technical values (IDs, URLs, hashes, emails, codes) as LTR
 * inside RTL operator chrome. Presentational only — does not alter data.
 */
export function LtrIsolate({
  children,
  as: Tag = "bdi",
  className = "",
  mono = false,
  ...rest
}: Props) {
  const classes = ["ltr-isolate", mono ? "latin-digits" : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag className={classes} dir="ltr" {...rest}>
      {children}
    </Tag>
  );
}
